import type { ReactNode } from 'react';

import { ADMIN_CARD, glassWashClass } from '@/shared/ui-class';
import { cn } from '@/shared/cn';

export type AdminSectionCardProps = {
  title?: string;
  description?: string;
  actions?: ReactNode;
  tone?: 'default' | 'info';
  children?: ReactNode;
  className?: string;
};

export function AdminSectionCard({
  title,
  description,
  actions,
  tone = 'default',
  children,
  className,
}: AdminSectionCardProps) {
  const hasHeader = title || description || actions;

  return (
    <section
      className={cn(
        ADMIN_CARD,
        glassWashClass(tone === 'info' ? 'info' : 'default'),
        className,
      )}
    >
      {hasHeader ? (
        <div
          className={cn(
            'flex flex-wrap items-start justify-between gap-3',
            children && 'pb-4',
          )}
        >
          <div className="min-w-0 flex-1">
            {title ? (
              <h2 className="text-sm font-medium text-zinc-900 dark:text-zinc-100">
                {title}
              </h2>
            ) : null}
            {description ? (
              <p
                className={cn(
                  'text-sm text-muted',
                  title && 'mt-1',
                )}
              >
                {description}
              </p>
            ) : null}
          </div>
          {actions ? (
            <div className="flex shrink-0 items-center gap-2">{actions}</div>
          ) : null}
        </div>
      ) : null}
      {children}
    </section>
  );
}
